// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__181YC","topBottomGutter":"Layout_topBottomGutter__3z9YM"};